import React from 'react';
import { Row, Col } from 'antd';
import { PlanStepsView } from './PlanStepsView';

export const PlanProcessView: React.FC = () => {
  return (
    <Row>
      <Col span={24}>
        <PlanStepsView />
      </Col>
    </Row>
  );
};
